import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Page } from "../types";
import { PageDB } from "./Pages";

export const getPagesListByBrand = async (brandId: string): Promise<Page[]> => {
  const collectionRef = collection(db, `brands/${brandId}/pages`);

  const q = query(collectionRef, orderBy("order", "asc"));

  const pagesSnapshot = await getDocs(q);

  return pagesSnapshot.docs.map((doc) => new PageDB(doc).toPage());
};
